function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M5.106 5.106c.293-.293.767-.293 1.06 0L12 10.939l5.834-5.833c.266-.267.683-.29.976-.073l.084.073c.293.293.293.767 0 1.06L13.061 12l5.833 5.834c.267.266.29.683.073.976l-.073.084c-.293.293-.767.293-1.06 0L12 13.061l-5.834 5.833c-.266.267-.683.29-.976.073l-.084-.073c-.293-.293-.293-.767 0-1.06L10.939 12 5.106 6.166c-.267-.266-.29-.683-.073-.976z",
  transform: "translate(-321 -38) translate(321 38)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/close.8b53b137.svg";
export { SvgComponent as ReactComponent };